import React from "react";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {Space, Typography} from "antd";
import {useTranslate} from "../../hooks/translate.hook";
import {RouteButtons} from "../common/route-tabs/route.buttons";

export const HealthCenter: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {

    const t = useTranslate();

    return (
        <Space direction="vertical" size={[0, 0]}>
            <Typography.Title level={3}>{t("HEALTH-CENTER.TITLE")}</Typography.Title>
            <RouteButtons routes={routeChildren!} />
        </Space>
    );
};
